import { isStructuredContent, type StructuredContent } from '../types';

export function injectCollapse(
  children: StructuredContent | StructuredContent[],
  collapse: boolean,
): StructuredContent | StructuredContent[] {
  const inject = (child: StructuredContent): StructuredContent => {
    if (!isStructuredContent(child) || child.type !== 'Column') return child;

    return { ...child, props: { ...child.props, __collapse: collapse } };
  };

  return Array.isArray(children) ? children.map(inject) : inject(children);
}
